import { find } from '../helpers';

const element = find('a[href^="#"]')

if (element) {
    import('./index')
}
